import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ScrollSpy from "react-ui-scrollspy";
import ContactCTA from "../contact/contactCTA";
import Projects from "../web_development/Projects";
import Testimonials from "../web_development/Testimonials";
import DashboardBanner from "./DashboardBanner";
import DashboardFAQ from "./DashboardFAQ";
import DashboardServices from "./DashboardServices";

const DashboardHome = () => {
  return (
    <div>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Flint Infotech - Transform Your Business with IT Solutions
          </title>
          <meta
            name="description"
            content="Flint InfoTech provides cutting-edge IT services, including web development, database migration, AI Solutions, and cloud management. Unlock the transformative potential of IT solutions for your business."
          />
          <link rel="canonical" href="https://flintinfotech.com/" />
          <meta
            name="keywords"
            content="IT services, IT consulting, web development, database migration, AI Solutions, cloud management, cloud migration, cloud consultation"
          />
          <meta name="author" content="Flint Infotech" />
          <meta name="robots" content="index, follow" />
        </Helmet>
      </HelmetProvider>

      <ScrollSpy>
        <DashboardBanner />
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <DashboardServices />
        </AnimationOnScroll>
        <div
          className="overflow-hidden bg-gradient-to-b from-blue-100 to-indigo-100
"
        >
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
            className="relative block h-[83px]"
            style={{ width: " calc(100% + 1.3px)" }}
          >
            <path
              d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
              opacity=".25"
              className="fill-white"
            ></path>
            <path
              d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
              opacity=".5"
              className="fill-white"
            ></path>
            <path
              d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
              className="fill-white"
            ></path>
          </svg>

          <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
            <Projects />
          </AnimationOnScroll>

          <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
            <Testimonials />
          </AnimationOnScroll>

          <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
            <DashboardFAQ />
          </AnimationOnScroll>

          <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
            {/* <Contact /> */}
            <ContactCTA />
          </AnimationOnScroll>
        </div>
      </ScrollSpy>
    </div>
  );
};

export default DashboardHome;
